var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-link mr-2 font-weight-bold",attrs:{"title":"Modo oscuro / claro"},on:{"click":function($event){return _vm.setTheme(!_vm.dark)}}},[_c('transition',{attrs:{"name":"bounce"}},[(_vm.dark)?_c('i',{staticClass:"fas fa-sun text-warning"}):_c('i',{staticClass:"fas fa-moon text-dark"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }